import { render, staticRenderFns } from "./SabbaticalItems.vue?vue&type=template&id=211f2794&scoped=true&"
import script from "./SabbaticalItems.vue?vue&type=script&lang=js&"
export * from "./SabbaticalItems.vue?vue&type=script&lang=js&"
import style0 from "./SabbaticalItems.vue?vue&type=style&index=0&id=211f2794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f2794",
  null
  
)

export default component.exports